import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { AlooraHeaderService } from './aloora-header.service';

@Injectable({
  providedIn: 'root',
})
export class AlooraTitleStrategy extends TitleStrategy {
  private readonly translate = inject(TranslateService);
  private readonly alooraHeaderService = inject(AlooraHeaderService);

  private subscription: Subscription | undefined;

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (!title) {
      return;
    }
    this.setTitle(title);
  }

  private setTitle(title: string | string[]) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }

    if (title === '') {
      this.alooraHeaderService.setTitle('');
      return;
    }

    this.subscription = this.translate
      .stream(title)
      .pipe(
        map((translatedTitle) =>
          typeof translatedTitle === 'object'
            ? Object.values(translatedTitle)?.join(' ')
            : translatedTitle,
        ),
      )
      .subscribe((title: string) => {
        this.alooraHeaderService.setTitle(title);
      });
  }
}
